// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__FKBsf","inner":"Footer_inner__2Bywp"};